// AUTO-GENERATED by generate-rxdb-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { defaultHooks } from '../defaults'

const name = 'processsteps'

/**
 * ProcessSteps Model Interface (auto-generated from Drizzle schema)
 */
export interface ProcessStepsModel {
  id: string
  orgId: string
  workspaceId: string
  userId?: string
  createdAt: string
  updatedAt: string
  metadata?: Record<string, unknown>
  extended?: Record<string, unknown>
  processId: string
  templateId?: string
  name: string
  title: string
  description?: string
  stepType: string
  order: number
  optional: boolean
  enabled: boolean
  nextStepId?: string
  action?: Record<string, unknown>
  conditions?: Record<string, unknown>[]
  outputs?: Record<string, unknown>[]
  outputExtraction?: Record<string, unknown>
  inputs?: Record<string, unknown>
  requiredVariables?: string[]
  position?: Record<string, unknown>
  estimatedDurationMinutes?: number
  icon?: string
  archived: boolean
  tenantId?: string
}

export const schema = {
  title: name,
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
      "id": {
          "type": "string",
          "maxLength": 100
      },
      "orgId": {
          "type": "string",
          "maxLength": 100
      },
      "workspaceId": {
          "type": "string",
          "maxLength": 100
      },
      "userId": {
          "type": "string",
          "maxLength": 100
      },
      "createdAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "updatedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "metadata": {
          "type": "object"
      },
      "extended": {
          "type": "object"
      },
      "processId": {
          "type": "string",
          "maxLength": 100
      },
      "templateId": {
          "type": "string",
          "maxLength": 100
      },
      "name": {
          "type": "string",
          "maxLength": 500
      },
      "title": {
          "type": "string",
          "maxLength": 500
      },
      "description": {
          "type": "string",
          "maxLength": 100000
      },
      "stepType": {
          "type": "string",
          "maxLength": 200
      },
      "order": {
          "type": "number",
          "minimum": 0,
          "maximum": 999999,
          "multipleOf": 0.01
      },
      "optional": {
          "type": "boolean"
      },
      "enabled": {
          "type": "boolean"
      },
      "nextStepId": {
          "type": "string",
          "maxLength": 100
      },
      "action": {
          "type": "object"
      },
      "conditions": {
          "type": "array",
          "items": {
              "type": "object"
          }
      },
      "outputs": {
          "type": "array",
          "items": {
              "type": "object"
          }
      },
      "outputExtraction": {
          "type": "object"
      },
      "inputs": {
          "type": "object"
      },
      "requiredVariables": {
          "type": "array",
          "items": {
              "type": "string"
          }
      },
      "position": {
          "type": "object"
      },
      "estimatedDurationMinutes": {
          "type": "integer"
      },
      "icon": {
          "type": "string",
          "maxLength": 50
      },
      "archived": {
          "type": "boolean"
      },
      "tenantId": {
          "type": "string",
          "maxLength": 100
      }
  },
  required: [
      "id",
      "orgId",
      "createdAt",
      "updatedAt",
      "processId",
      "name",
      "title",
      "stepType",
      "order",
      "optional",
      "enabled",
      "archived",
      "workspaceId"
  ],
  indexes: [
      [
          "processId",
          "order"
      ],
      [
          "processId",
          "stepType"
      ],
      [
          "orgId",
          "workspaceId",
          "createdAt"
      ]
  ],
}

export const migrationStrategies = {}

export const Collection = {
  name,
  schema,
  hooks: {
    ...defaultHooks({ name }),
  },
  migrationStrategies,
}
